module.exports = __webpack_public_path__ + "static/media/Icon_CreateNewProject.27f648fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_CreateNewProject.svg
// module id = 2314
// module chunks = 0